export default __webpack_public_path__ + "static/media/10(GRAND-PARK-HOTEL).cb149e66.jpg";